import { defineComponent as _defineComponent } from 'vue'
import SvgIcon from '../common/base/SvgIcon.vue';
import AudioSettingTab from '../common/AudioSettingTab.vue';
import VideoSettingTab from '../common/VideoSettingTab.vue';
import { useBasicStore } from '../../stores/basic';
import { storeToRefs } from 'pinia';
import { SettingMode } from '../../constants/render';
import { useI18n } from '../../locales';
import { computed } from 'vue';
import CloseIcon from '../common/icons/CloseIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

// import { ref } from 'vue';
const { t } = useI18n();

const basicStore = useBasicStore();

const { showSettingDialog, activeSettingTab } = storeToRefs(basicStore);

const settingTabsTitleList = computed(() => [
  { label: t('Audio settings'), value: 'audio' },
  { label: t('Camera settings'), value: 'video' },
]);

function handleUpdateActiveTab(tabTitle: string) {
  basicStore.setActiveSettingTab(tabTitle);
}

function handleCloseSettingDialog() {
  basicStore.setShowSettingDialog(false);
}

function handleOverlayClick(event: any) {
  if (event.target !== event.currentTarget) {
    return;
  }
  handleCloseSettingDialog();
}

return { __sfc: true,t, basicStore, showSettingDialog, activeSettingTab, settingTabsTitleList, handleUpdateActiveTab, handleCloseSettingDialog, handleOverlayClick, SvgIcon, AudioSettingTab, VideoSettingTab, SettingMode, CloseIcon }
}

})